import React from "react";
import Header from "../../Layouts/Header";
import "./index.css"; // Import the CSS file
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

import "../../CommonContainer/common.css"
import teamImage from '../../../Assets/images/aboutimages/team.png'; // Replace with your path
import founderImage from '../../../Assets/images/aboutimages/founder.png'; // Replace with your path
import journeyImage from "../../../Assets/images/aboutimages/journeyImage.png"
import bannerSubimg from "../../../Assets/images/contact-img.png"
import ParticleImage from "../../CommonContainer/ParticleImage";

// import Necklace from "../../CommonContainer/Necklace";

const ContactUS = () => {
    return (
        <><div>
            <div className="about-hero-section contact-banner">
                <Header />
                <div className="common-width-home-main-container">
                    <div className="about-banner1-main-section">
                        <div>
                            <h1>We’re Here to Assist You – With Grace & Tradition</h1>
                            <p>Whether it’s a custom silver order or a product inquiry, our team is always ready to help. </p>
                            {/* <button className="contact-button">Contact Us</button> */}
                        </div>
                        <img src={bannerSubimg} alt="banner1" />
                    </div>
                </div>
            </div>

            <div className="jewellery-carousel-section">
                {/* <Necklace /> */}
                <div className="contact-wrapper">
                    <h2 className="contact-title">Get In Touch</h2>
                    <p className="contact-subtitle">
                        Have a question or need assistance? We're just a message away. Connect
                        with Sreerasthu Silvers for personalized support and timeless craftsmanship.
                    </p>

                    <div className="contact-content">
                        <div className="content-container">
                            <div className="contact-item">
                                <FaMapMarkerAlt className="contact-icon" />
                                 <span className = "ch">Location
                                    <br/>
                                      <span className="cp">Sreerasthu Silvers, Ramasomayajulu St, Rama <br/>
                                      Rao Peta,
                                        Kakinada, Andhra Pradesh 533001
                                      </span>
                                 </span>
                            </div>

                             <div className="contact-item">
                                <FaEnvelope className="contact-icon" />
                                <span className = "ch">
                                    Email <br/>
                                    <span className="cpp">sreerasthusilvers@gmail.com</span>
                                </span>
                              
                            </div>

                             <div className="contact-item">
                                <FaPhoneAlt className="contact-icon" />
                                 <span className = "ch">
                                    Phone <br/>
                                    <span className="cpp">6304960489</span>
                                </span>
                              
                            </div>
                        </div>

                        <div className="contact-map-box">
                            <iframe
                                title="Sreerastu Silvers Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3687.1417050800533!2d82.23205947500003!3d16.95778168385799!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a38290006734e2b%3A0x9f8b6cdf933bc2a!2sSreerastu%20silvers!5e1!3m2!1sen!2sin!4v1749377738065!5m2!1sen!2sin"
                                width="100%"
                                height="385"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default ContactUS;
